module.exports = __webpack_public_path__ + "img/1.2d5a9a0e.png";